import user from "../../../enums/user";

/*=========================================================================================
  File Name: moduleKindsMutations.js
  Description: Kinds Module Mutations
  ----------------------------------------------------------------------------------------
==========================================================================================*/
export default {
  SET_STATUS (state, status) {
    state.listStatus = status
  },
  SET_INFO_DB(state, payload){
    state.infoDB = payload
  }
}